import type { ColorTokens } from "tamagui";
import { getTokenValue } from "tamagui";
import { useTheme, variableToString } from "@tamagui/core";
import type { IconSizeToken } from "../../themes/token-size";
import { LottieAnimation } from "../LottieAnimation";
import source from "./loading-spinner.json";
export type LoaderProps = {
  size?: IconSizeToken;
  /**
   * Tint color for the spinner. Accepts a Tamagui color token.
   * @default "$iconDefault"
   */
  color?: ColorTokens;
};

/**
 * Keypaths inside `loading-spinner.json` that should be tinted on native.
 * Matches the layer hierarchy: Spinner → Arc → Circle → Stroke.
 */
const SPINNER_COLOR_KEY_PATHS = ["Spinner.Arc 1.Circle.Stroke", "Spinner.Arc 2.Circle.Stroke"];

/**
 * Cross-platform loading spinner powered by Lottie.
 *
 * Delegates rendering to `LottieAnimation`, which picks the correct Lottie
 * library for the current platform (`lottie-react` on web, `lottie-react-native`
 * on iOS/Android).
 */
export const Loader = ({
  size = "$iconMedium",
  color = "$iconDefault"
}: LoaderProps) => {
  const pixels = Number(getTokenValue(size, "size"));
  const theme = useTheme();
  const resolvedColor = variableToString(theme[color]);
  return <LottieAnimation source={source} width={pixels} height={pixels} color={resolvedColor} colorKeyPaths={SPINNER_COLOR_KEY_PATHS} data-sentry-element="LottieAnimation" data-sentry-component="Loader" data-sentry-source-file="Loader.tsx" />;
};